
import { initializeApp } from "firebase/app";
import { 
  getAuth, 
  GoogleAuthProvider, 
  GithubAuthProvider 
} from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFirestore } from "firebase/firestore";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDplHtMWuModagyDzGi-0GTHq_igOh8xUg",
  authDomain: "kamuska-cc905.firebaseapp.com",
  projectId: "kamuska-cc905",
  storageBucket: "kamuska-cc905.firebasestorage.app",
  messagingSenderId: "653876986124",
  appId: "1:653876986124:web:01d7354fd2555ba47b4929",
  measurementId: "G-TGLB2CW3QW"
};

const app = initializeApp(firebaseConfig);

// ✅ AUTH
export const auth = getAuth(app);

// ✅ PROVIDERS (THIS FIXES YOUR ERROR)
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();

export const storage = getStorage(app);

// ✅ DATABASES
export const db_fire = getFirestore(app);
export const db = getDatabase(app);
